import type { LegalDocument, Me } from '../api/client'

// pendingAgreements are the agreements she must accept before using the app.
// An API that predates agreements sends none, which reads as nothing pending.
export function pendingAgreements(me: Me | null): LegalDocument[] {
  return me?.legal_pending ?? []
}

// agreementsSentence names them as she would say it: "the Terms of Service
// and the Data Processing Agreement".
export function agreementsSentence(docs: LegalDocument[]): string {
  const titles = docs.map((d) => `the ${d.title}`)
  if (titles.length <= 1) return titles.join('')
  return `${titles.slice(0, -1).join(', ')} and ${titles[titles.length - 1]}`
}

// inApp says whether she reads a document in the app itself (its url is a
// path with no host, which the API serves to her signed in: the DPIA) or on
// harmovi.com in a new tab.
export function inApp(doc: LegalDocument): boolean {
  return doc.url.startsWith('/')
}

// agreementGroups sets the DPIA apart from the contract (the terms, the DPA):
// she signs the contract for herself, but adopts the DPIA for her clients, so
// each has a tickbox of its own. Order is kept.
export function agreementGroups(docs: LegalDocument[]): { contract: LegalDocument[]; dpia: LegalDocument[] } {
  return {
    contract: docs.filter((d) => d.document !== 'dpia'),
    dpia: docs.filter((d) => d.document === 'dpia'),
  }
}
